<div class="colorPicker">
  <mat-form-field appearance="outline"
                  (click)="isOpen = true">
    <mat-label>{{ field.key | translate }}</mat-label>
    <input matInput
           ignoreInputScroll
           type="text"
           autocomplete="off"
           [formControl]="field.control"
           placeholder="{{ field.key | translate }}" />
    <mat-icon matSuffix [style.color]="field.control.value">palette</mat-icon>
  </mat-form-field>
  <div class="colorField"
       [style.background]="field.control.value"
       [class.active]="isOpen"
       [(cpToggle)]="isOpen"
       [cpPosition]="'bottom'"
       [cpPositionOffset]="'50%'"
       [cpPositionRelativeToArrow]="false"
       [cpUseRootViewContainer]="true"
       [cpSaveClickOutside]="true"
       [cpOutputFormat]="'hex'"
       [cpAlphaChannel]="'disabled'"
       [cpFallbackColor]="field.control.value"
       [colorPicker]="field.control.value"
       (colorPickerChange)="onColorChange($event)"></div>
</div>
